import {FormattedMessage, useIntl} from "react-intl";
import StartBtn from "images/IPX/Runnerz/runnerz_button_start.png";
import RankingBtn from "images/IPX/Runnerz/runnerz_button_rank.png";
import LandingBg from "images/IPX/Runnerz/ipx_runnerz_title_background_01.png";
import TitleLogo from "images/IPX/Runnerz/runnerz_font_title.png";
import classNames from "classnames/bind";
import styles from "./index.module.scss";
import {GAME_STATE} from "utils";

const cn = classNames.bind(styles);

function LandingScreen({
  user,
  gameState,
  onClickStart,
  onClickRanking,
  onClickLogout,
}) {
  const intl = useIntl();

  return (
    <div className={cn("landing")}>
      <img alt="background img" src={LandingBg} />
      <div className={cn("inner")}>
        <div className={cn("top")}>
          <img alt="runnerz logo" src={TitleLogo} className={cn("logo")} />
        </div>

        <div className={cn("bottom")}>
          {gameState === GAME_STATE.LOADED ? (
            <>
              <div className={cn("title_buttons")}>
                <button
                  className={cn("ranking")}
                  type="button"
                  onClick={onClickRanking}
                >
                  <img alt="ranking" src={RankingBtn} />
                </button>
                <button
                  className={cn("game_start")}
                  type="button"
                  onClick={onClickStart}
                >
                  <img alt="game start" src={StartBtn} />
                </button>
              </div>
            </>
          ) : (
            <p className={cn("loading_text")}>
              월드를 불러오는 중입니다. 잠시만 기다려 주세요.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default LandingScreen;
